import React, { Component } from 'react';
import { message, Form, Icon, Input, Popconfirm, InputNumber, Button, Table } from "antd";

import { Redirect } from 'react-router-dom'


// We import our firestore module
import { db, storr } from '../firebase/firebase';
import moment from 'moment';



const data = [];

//=================editable==========================
const FormItem = Form.Item;
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
    <EditableContext.Provider value={form}>
        <tr {...props} />
    </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);
//=================editable==========================



class EditableCell extends React.Component {
    getInput = () => {
        if (this.props.inputType === 'number') {
            return <InputNumber />;
        }
        return <Input />;
    };

    render() {
        const {
            editing,
            dataIndex,
            title,
            inputType,
            record,
            index,
            ...restProps
        } = this.props;
        return (
            <EditableContext.Consumer>
                {(form) => {
                    const { getFieldDecorator } = form;
                    return (
                        <td {...restProps}>
                            {editing ? (
                                <FormItem style={{ margin: 0 }}>
                                    {getFieldDecorator(dataIndex, {
                                        rules: [{
                                            required: true,
                                            message: `Please Input ${title}!`,
                                        }],
                                        initialValue: record[dataIndex],
                                    })(this.getInput())}
                                </FormItem>
                            ) : restProps.children}
                        </td>
                    );
                }}
            </EditableContext.Consumer>
        );
    }
}


class Media extends Component {
    constructor(props) {
        super(props);
        this.state = {
            invalidPage: false,
            checky: false,
            selectedFile: null,
            disallow: true,
            downloadlink: "",
            pendingData: { disabled: true, inputDisabled: false },
            data,
            dd: null,
            da: null,
            ta: null,
            na: null,
            la: null,
            master: [],
            sd: [],
            editingKey: ''
        };


        this.columns = [
            // {
            //     title: 'Actual file name',
            //     dataIndex: 'actualfilename',
            //     editable: true,
            //     sorter: (a, b) => { return a.actualfilename.localeCompare(b.actualfilename) },
            // },
            {
                title: 'File name',
                dataIndex: 'filename',
                editable: true,
                sorter: (a, b) => { return a.filename.localeCompare(b.filename) },
            },
            // {
            //     title: 'Link',
            //     dataIndex: 'link',
            //     width: '20%',
            // },
            {
                title: 'Upload Date',
                dataIndex: 'timestamp',
                sorter: (a, b) => parseInt(a.timestamp, 10) - parseInt(b.timestamp, 10),
                render: (text, record) => {
                    return (
                        <div>
                            {this.toLocalTime(text)}

                        </div>
                    );
                },
            },
            {
                title: 'Media Link',
                dataIndex: 'link',
                editable: false,
                render: (text, record) => {
                    return (
                        <div>
                            <a onClick={evt => this.openlink(record.key)}>
                                <img src={this.state.data[record.key].link} height='150' />
                            </a>
                        </div>
                    );
                },
            },
            {
                title: '',
                width: '10%',
                dataIndex: 'operation',
                render: (text, record) => {
                    return (
                        <div>
                            <Popconfirm
                                title="Sure to delete?"
                                onConfirm={() => this.deleteProject(record.key)}
                            >
                                <Button type='danger'><Icon type="delete" /></Button>
                            </Popconfirm>
                        </div>
                    );
                },
            },
        ];

        this.pullFromDB = this.pullFromDB.bind(this);
        this.updateProject = this.updateProject.bind(this);

        this.pullFromDB();
    }

 
    toLocalTime = (ts) => {
        var dt = new Date(ts).toLocaleString();
        return dt
    }

    isEditing = (record) => {
        return record.key === this.state.editingKey;
    };

    edit(key) {
        this.setState({ editingKey: key });
    }

    save(form, key) {
        form.validateFields((error, row) => {
            if (error) {
                return;
            }
            const newData = [...this.state.data];
            const index = newData.findIndex(item => key === item.key);
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {
                    ...item,
                    ...row,
                });

                // this.state.da = newData[index].date
                // this.state.la = newData[index].actualfilename
                this.updateProject(index)

                this.setState({ data: newData, editingKey: '' });
            } else {
                newData.push(row);
                this.setState({ data: newData, editingKey: '' });
            }
        });
    }

    cancel = () => {
        this.setState({ editingKey: '' });
    };



    handleChange = () => {
        // 
        // this.addEvent();
        let sd = [];
        //asign key to the array!
        for (var i = 0; i < Object.keys(this.state.master.medias).length; i++) {

            sd.push({
                link: Object.values(this.state.master.medias)[i],
                key: i.toString(),
            });

            // console.log("SD state!! " + JSON.stringify(this.state.sd))
            // console.log("DATA state!! " + JSON.stringify(this.state.data))
        }
        this.setState({ sd });
    }

    pullFromDB() {
        var baba;
        if (this.props.match.params.id) {
            baba = this.props.match.params.id
        }
        // We listen for live changes to our data collection in Firebase
        db.collection("eventmedia").where("event", "==", baba).onSnapshot(snapshot => {
            //data is locally available array, pulled from firestore.
            let data = [];
            snapshot.forEach(doc => {
                const todo = doc.data();
                todo.id = doc.id;
                data.push(todo);
            });

            // Sort our data based on time added
            //sort by timestamp
            data.sort((a, b) => (a.timestamp > b.timestamp) ? -1 : 1)

            //assign primary key
            for (var i = 0; i < data.length; i++) {
                data[i].key = i;
            }
            // console.log(data);

            // Anytime the state of our database changes, we update state
            this.setState({ data });

        })
        // var ref = db.collection("eventmedia").doc(this.props.match.params.id)
        // ref.get().then((doc) => {

        //     this.setState({
        //         master: doc.data(),
        //     });
        //     this.handleChange();
        // })


    }

    updateLinks = () => {
        for (var i = 0; i < this.state.data.length; i++) {
            if (this.state.data[i].link === "Generating link...") {
                this.openlink(i)
            }
        }
    }

    async updateProject(id) {
        await db
            .collection("eventmedia")
            .doc(this.state.data[id].id).update({
                name: this.state.na,
            })
            .then(function () {
                message.success("Document successfully updated!");
            })
            .catch(function (error) {
                // The document probably doesn't exist.
                message.error("Error updating document: " + error);
            });
    }



    openlink = (key) => {
        // db.collection("eventmedia").doc(id).get().then(function (doc) {
        //     if (doc.exists) {
        //         console.log("Document data:", doc.data().name);
        //     }})
        // var bb = this.state.data[key].id
        // // Create a reference with an initial file path and name
        // var ref = storr.ref(this.state.data[key].actualfilename);
        // Get the download URL
        window.open(this.state.data[key].link, '_blank');

        // ref.getDownloadURL().then(function (url) {
        //     // Insert url into an <img> tag to "download"
        //     //open the link of the url.
        //     window.open(url, '_blank');
        //     // db.collection("eventmedia").doc(bb).update({link: url})
        // })
    }


    //OLD VERSION THAT USE AXIOS HTTP REQUEST TO CLOUD FUNCTION.
    // fileUpload = () => {
    //     var na = moment().toISOString()
    //     const formData = new FormData()
    //     formData.append('image', this.state.selectedFile, na + this.state.selectedFile.name)
    //     axios.post('https://us-central1-lemonbase-ee2df.cloudfunctions.net/uploadFile', formData, {
    //         onUploadProgress: progressEvent => {
    //             console.log(progressEvent.loaded / progressEvent.total)
    //         }
    //     })
    //         .then(res => console.log(res))
    //     this.addProject(na, this.state.selectedFile.name);
    // }

    fileUpload = () => {


    }


    blockit = () => {
        this.state.disallow = true;
        this.setState({ disallow: true })
    }





    clearInputFile = () => {
        var tempB = this.state.pendingData
        document.getElementById("uploadCaptureInputFile").value = ""
        tempB.file = null
        tempB.disabled = true
        this.setState({ pendingData: tempB })
    }

    handlePreuploadFile = (event) => {
        var abb = this.state.pendingData;

        if (event.target.files[0]) {
            if (event.target.files[0].type === 'image/png' || event.target.files[0].type === 'image/jpeg' || event.target.files[0].type == 'video/mp4') {
                console.log("accepted file format")
                if (event.target.files[0].size < 100000000) {
                    abb.disabled = false
                    message.info("You inputed " + event.target.files[0].name)
                    abb.file = event.target.files[0]
                } else {
                    message.error("File is too big");
                    event.target.value = ""
                    abb.file = null
                    abb.disabled = true
                }
            } else {
                message.error("Not the accepted file type");
                event.target.value = ""
                abb.file = null
                abb.disabled = true
            }
        } else {
            message.error("No file in it");
            event.target.value = ""
            abb.file = null
            abb.disabled = true
        }

        this.setState({ pendingData: abb });
    }

    addProject = () => {
        if (this.state.pendingData.file != null) {
            var tempC = this.state.pendingData
            tempC.inputDisabled = true
            tempC.disabled = true
            this.setState({ pendingData: tempC })

            this.uploadThenAddToDatabase(this.state.pendingData)
        } else {
            message.error("Something wrong happened, no file was in it")
        }

    }

    uploadThenAddToDatabase = (ahh) => {
        message.loading('Uploading...')
        console.log(JSON.stringify(ahh))
        var docy = db.collection("eventmedia").doc()
        var timetampy = Date.now()
        var refy = storr.ref(timetampy + '-' + docy.id + ahh.file.name.substring(ahh.file.name.lastIndexOf('.'), ahh.file.name.length));

        var self = this

        refy.put(ahh.file).then(function (doc) {
            refy.getDownloadURL().then((url) => {
                docy.set({
                    timestamp: timetampy,
                    event: self.props.match.params.id,
                    filename: ahh.file.name,
                    link: url
                })
                if (document.getElementById("uploadCaptureInputFile"))
                    document.getElementById("uploadCaptureInputFile").value = ""
                ahh.file = null
                ahh.inputDisabled = false
                ahh.disabled = true
                self.setState({ pendingData: ahh })
                message.destroy()
                message.success("Uploaded successfully")
            })

        });
    }

    deleteProject = (id) => {
        // alert("record.key: " + id + "todo id: " + this.state.data[id].id)
        var fn = this.state.data[id].filename
        var idea = this.state.data[id].id
        var tsy = this.state.data[id].timestamp

        var ext = fn.substring(fn.lastIndexOf('.'), fn.length)

        db
            .collection("eventmedia")
            .doc(idea)
            .delete().then(function () {
                message.success("Row deleted successfully")
                var ref = storr.ref(tsy + '-' + idea + ext);
                // Get the download URL
                ref.delete().then(function () {
                    message.success("File " + fn + " deleted successfully")
                }).catch(function (error) {
                    message.error(error.message)
                });
            }).catch(function (error) {
                message.error(error.message)
            });
    }
    //========================================================================================
    render() {
        const components = {
            body: {
                row: EditableFormRow,
                cell: EditableCell,
            },
        };

        const columns = this.columns.map((col) => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    inputType: col.dataIndex === 'age' ? 'number' : 'text',
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: this.isEditing(record),
                }),
            };
        });

        return (
            <div>
                <h1>{this.props.match.params.title}</h1>
                <br></br>
                {/* <div className="upload-btn-wrapper">
                    <button className="btn">Upload a file</button>
                    <input type="file"
                        accept="image/png, image/jpeg, video/mp4"
                        onChange={this.handlefile}
                    />
                </div> */}

                <div className="gutter-box">
                    <Button
                        type="danger"
                        onClick={this.clearInputFile}
                        disabled={this.state.pendingData.inputDisabled}
                        ghost
                    >
                        Clear file
                </Button>
                </div>
                <input type="file"
                    id="uploadCaptureInputFile"
                    accept="image/png, image/jpeg, video/mp4"
                    onChange={this.handlePreuploadFile}
                    disabled={this.state.pendingData.inputDisabled}
                />
                <div className="gutter-box">
                    <Button
                        className="inputt App-add-todo-button"
                        size="large"
                        type="primary"
                        onClick={this.addProject}
                        disabled={this.state.pendingData.disabled}
                    >
                        Add a Media file
          </Button>
                </div>

                < Table
                    components={components}
                    bordered
                    dataSource={this.state.data}
                    columns={columns}
                    rowClassName="editable-row"
                />
                {this.state.invalidPage ?
                    <Redirect to='/dashboard' />
                    :
                    <div />
                }
            </div >
        );
    }
}

export default Media;



// WEBPACK FOOTER //
// ./src/views/media.js